import { isValidElement } from 'react';
import Slottable from './slottable';
export const isSlottable = (child) => {
    return isValidElement(child) && child.type === Slottable;
};
//# sourceMappingURL=utils.js.map